export default function globalFn() {
    var YSY = (function () {
        return {
            init() {
                // 重写toFixed
                /**
                 * 重写Number的toFixed方法，保留小数点后len长度的小数位数
                 */
                Number.prototype.toFixed = function (len) {
                    return YSY.accCount(YSY.dokxjsf(this), 1, len, '1')
                }
                // 初始化
                console.log('E税云初始化...')
                YSY.user.init()
            },
            accCount(arg1, arg2, pointNum, addFlag) {
                /**
                 * 除法运算
                 * */
                const bcsNum = `${arg1}`
                const csNum = `${arg2}`
                let zeroStr = '.'
                let addpointNum = 0

                // 被除数根据精度补零
                if (bcsNum.indexOf('.') > 0) {
                    addpointNum = pointNum - (bcsNum.length - bcsNum.indexOf('.') - 1)
                    zeroStr = ''
                } else {
                    addpointNum = pointNum
                }
                for (let i = 0; i < addpointNum; i++) {
                    zeroStr += '0'
                }
                const BigBcsNum = new BigDecimal(bcsNum + zeroStr)
                const BigCsNum = new BigDecimal(csNum)
                let retNum = BigBcsNum.divide(BigCsNum).setScale(pointNum, BigDecimal.prototype.ROUND_HALF_UP).toString()
                if (addFlag == undefined) {
                    if (retNum.indexOf('.') > 0) {
                        let retNumP = retNum.substring(retNum.length - 1, retNum.length)
                        while (retNumP == '0') {
                            retNum = retNum.substring(0, retNum.length - 1)
                            retNumP = retNum.substring(retNum.length - 1, retNum.length)
                            if (retNumP == '.') {
                                retNum = retNum.substring(0, retNum.length - 1)
                            }
                        }
                    }
                }
                return retNum
            },

            cfCount(arg1, arg2, pointNum, addFlag) {
                /**
                 * 乘法运算
                 * */
                const bcsNum = `${arg1}`
                const csNum = `${arg2}`

                const BigBcsNum = new BigDecimal(bcsNum)
                const BigCsNum = new BigDecimal(csNum)
                let retNum = BigBcsNum.multiply(BigCsNum).setScale(pointNum, BigDecimal.prototype.ROUND_HALF_UP).toString()

                if (addFlag == undefined) {
                    if (retNum.indexOf('.') > 0) {
                        let retNumP = retNum.substring(retNum.length - 1, retNum.length)
                        while (retNumP == '0') {
                            retNum = retNum.substring(0, retNum.length - 1)
                            retNumP = retNum.substring(retNum.length - 1, retNum.length)
                            if (retNumP == '.') {
                                retNum = retNum.substring(0, retNum.length - 1)
                            }
                        }
                    }
                }
                return retNum
            },
            addCount(arg1, arg2, pointNum, addFlag) {
                /**
                 * 加法运算
                 * */

                const bcsNum = `${arg1}`
                const csNum = `${arg2}`

                const BigBcsNum = new BigDecimal(bcsNum)
                const BigCsNum = new BigDecimal(csNum)
                let retNum = BigBcsNum.add(BigCsNum).setScale(pointNum, BigDecimal.prototype.ROUND_HALF_UP).toString()

                if (addFlag == undefined) {
                    if (retNum.indexOf('.') > 0) {
                        let retNumP = retNum.substring(retNum.length - 1, retNum.length)
                        while (retNumP == '0') {
                            retNum = retNum.substring(0, retNum.length - 1)
                            retNumP = retNum.substring(retNum.length - 1, retNum.length)
                            if (retNumP == '.') {
                                retNum = retNum.substring(0, retNum.length - 1)
                            }
                        }
                    }
                }

                return retNum
            },
            subCount(arg1, arg2, pointNum, addFlag) {
                /**
                 * 减法运算
                 * */
                const bcsNum = `${arg1}`
                const csNum = `${arg2}`

                const BigBcsNum = new BigDecimal(bcsNum)
                const BigCsNum = new BigDecimal(csNum)
                let retNum = BigBcsNum.subtract(BigCsNum).setScale(pointNum, BigDecimal.prototype.ROUND_HALF_UP).toString()

                if (addFlag == undefined) {
                    if (retNum.indexOf('.') > 0) {
                        let retNumP = retNum.substring(retNum.length - 1, retNum.length)
                        while (retNumP == '0') {
                            retNum = retNum.substring(0, retNum.length - 1)
                            retNumP = retNum.substring(retNum.length - 1, retNum.length)
                            if (retNumP == '.') {
                                retNum = retNum.substring(0, retNum.length - 1)
                            }
                        }
                    }
                }

                return retNum
            },
            Add(num1, num2) {
                let r1
                let r2
                let m
                let n
                try {
                    r1 = num1.toString().split('.')[1].length
                } catch (e) {
                    r1 = 0
                }
                try {
                    r2 = num2.toString().split('.')[1].length
                } catch (e) {
                    r2 = 0
                }
                m = Math.pow(10, Math.max(r1, r2))
                n = (r1 >= r2) ? r1 : r2
                return (Math.round(num1 * m + num2 * m) / m).toFixed(n)
            },
            Sub(num1, num2) {
                let r1
                let r2
                let m
                let n
                try {
                    r1 = num1.toString().split('.')[1].length
                } catch (e) {
                    r1 = 0
                }
                try {
                    r2 = num2.toString().split('.')[1].length
                } catch (e) {
                    r2 = 0
                }
                m = Math.pow(10, Math.max(r1, r2))
                n = (r1 >= r2) ? r1 : r2
                return (Math.round(num1 * m - num2 * m) / m).toFixed(n)
            },
            Div(num1, num2) {
                if (!num1 || !num2) return 0
                let t1
                let t2
                let r1
                let r2
                try {
                    t1 = num1.toString().split('.')[1].length
                } catch (e) {
                    t1 = 0
                }
                try {
                    t2 = num2.toString().split('.')[1].length
                } catch (e) {
                    t2 = 0
                }
                r1 = Number(num1.toString().replace('.', ''))
                r2 = Number(num2.toString().replace('.', ''))
                return (r1 / r2) * Math.pow(10, t2 - t1)
            },
            Mul(num1, num2) {
                if (!num1 || !num2) return 0
                let m = 0
                const s1 = num1.toString()
                const s2 = num2.toString()
                try {
                    m += s1.split('.')[1].length
                } catch (e) {}
                try {
                    m += s2.split('.')[1].length
                } catch (e) {}
                return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
            },
            cookie(name, value, options) {
                if (typeof value !== 'undefined') {
                    options = options || {}
                    if (value === null) {
                        value = ''
                        options = $.extend({}, options)
                        options.expires = -1
                    }
                    let expires = ''
                    if (options.expires && (typeof options.expires === 'number' || options.expires.toUTCString)) {
                        let date
                        if (typeof options.expires === 'number') {
                            date = new Date()
                            date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000))
                            // date.setTime(date.getTime() + (options.expires * 30 * 60 * 1000));
                        } else {
                            date = options.expires
                        }
                        expires = `; expires=${date.toUTCString()}`
                    }
                    const path = options.path ? `; path=${options.path}` : ''
                    const domain = options.domain ? `; domain=${options.domain}` : ''
                    const secure = options.secure ? '; secure' : ''
                    document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('')
                } else {
                    let cookieValue = null
                    if (document.cookie && document.cookie != '') {
                        const cookies = document.cookie.split(';')
                        for (let i = 0; i < cookies.length; i++) {
                            const cookie = jQuery.trim(cookies[i])
                            if (cookie.substring(0, name.length + 1) == (`${name}=`)) {
                                cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
                                break
                            }
                        }
                    }
                    return cookieValue
                }
            },
            loadCSS(url, media) {
                const link = document.createElement('link')
                link.rel = 'stylesheet'
                link.type = 'text/css'
                link.href = url
                if (media) {
                    link.media = media
                }
                document.getElementsByTagName('head')[0].appendChild(link)
            },
            isPositiveFloatNum(argument) { // 是否正浮点数；
                const reg = /(^[\d]+$)|(^\d+(\.\d+)?$)/
                return reg.test(argument)
            },
            isNegativeFloatNum(argument) { // 是否负浮点数；
                const reg = /(^\-[\d]+$)|(^\-\d+(\.\d+)?$)/
                return reg.test(argument)
            },
            selfToFixed(v, n) {
                return parseFloat(v).toFixed(n)
            },
            dokxjsf(val) {
                /**
                 * 解决数值类型科学计数法问题
                 * @param {val}
                 */
                if (val == null) {
                    return ''
                }

                let valStr = val.toString()
                valStr = valStr.replace('E', 'e')
                if (valStr.indexOf('e') != -1) {
                    const len = valStr.length
                    const arr1 = valStr.split('e')
                    const left = arr1[0]
                    const arrLeft = left.split('.')
                    let leftws = 0
                    if (arrLeft.length > 1) {
                        leftws = arrLeft[1].length
                    }
                    const jingdu = leftws - parseInt(arr1[1]) < 0 ? 0 : leftws - parseInt(arr1[1]) // 精度为正
                    // val = val.toFixed(leftws+jingdu);//已替换为后一句的方法实现
                    val = new BigDecimal(valStr).setScale(jingdu, BigDecimal.prototype.ROUND_HALF_UP).toString()
                    return val
                }
                return val
            },

            cutOutPnumber(v, n) { // 截取正数
                if (this.isNullVal(v)) {
                    return v
                }
                var v = this.dokxjsf(v)
                if (this.isPositiveFloatNum(v)) {
                    const _str = `${v}`
                    const dotArr = _str.split(/[/.]/)
                    if (dotArr.length == 2 && dotArr[1].length > n) {
                        return this.selfToFixed(v, n)
                    }
                    return v
                }
                return v
            },
            cutOutNnumber(v, n) { // 截取负数
                if (this.isNullVal(v)) {
                    return v
                }
                var v = this.dokxjsf(v)
                if (this.isNegativeFloatNum(v)) {
                    const _str = `${v}`
                    const dotArr = _str.split(/[/.]/)
                    if (dotArr.length == 2 && dotArr[1].length > n) {
                        return this.selfToFixed(v, n)
                    }
                    return v
                }
                return v
            },
            isNullVal(v) {
                return v == null || v == undefined || v == ''
            },
            checkTax(nsrsbh, isBuyer) { // 验证税号
                const reg = /^[/d1-9A-Z]/ // 验证是否已数字开头
                const re = /^([\u4E00-\u9FA5]|\w)*$/ // 验证是否有特殊字符
                // 可以为15位、17位、18位和20位数字或字母
                let res = /^[\dA-Z]{15}$|^[\dA-Z]{17}$|^[\dA-Z]{18}$|^[\dA-Z]{20}$|^[\dA-Z]{21}$/
                if (isBuyer) res = /^([0-9A-Z]{6,20})$/
                const tax = $.trim(nsrsbh)
                if (tax.match(/[\u4e00-\u9fa5]/g) || !re.test(tax) || !reg.test(tax) || !res.test(tax)) {
                    return false
                }
                return true
            },
            isUrl(argument) { // 网址检测
                return /[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i.test(argument)
            },
            isIdCard(argument) { // 身份证检测
                return /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(argument)
            },
            isPhone(argument) { // 手机号码检测；
                const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
                return reg.test(argument)
            },
            isTel(argument) { // 电话号码检测；
                const reg = /^([0|4\+]\d{2,3}[—]?-)?(0|8\d{2,3}-)?(\d{4,8})(-\d{1,4})?$/
                return reg.test(argument)
            },
            isEmail(argument) { // Email检测；
                const reg = /^[a-z0-9_\-]+(\.[_a-z0-9\-]+)*@([_a-z0-9\-]+\.)+([a-z]+)$/
                return reg.test(argument)
            },
            isIp(argument) { // ip校验
                const reg = /^(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])$/
                return reg.test(argument)
            },
            isPort(argument) { //端口校验
                const reg = /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{4}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/
                return reg.test(argument) && argument > 0
            },
            randomNum(min, max) { // 生成随机数
                return Math.floor(min + Math.random() * (max - min))
            },
            randomColor() { // 随机色
                return `#${(`00000${(Math.random() * 0x1000000 << 0).toString(16)}`).slice(-6)}`
            },
            arrayEqual(arr1, arr2) { // 对比数组相等
                if (arr1 === arr2) {
                    return true
                }
                if (arr1.length != arr2.length) {
                    return false
                }
                for (let i = 0; i < arr1.length; ++i) {
                    if (arr1[i] !== arr2[i]) {
                        return false
                    }
                }
                return true
            },
            hasClass(ele, cls) {
                return (new RegExp(`(\\s|^)${cls}(\\s|$)`)).test(ele.className)
            },
            addClass(ele, cls) {
                if (!this.hasClass(cls)) {
                    ele.className += ` ${cls}`
                }
            },
            removeClass(ele, cls) {
                if (this.hasClass(cls)) {
                    const reg = new RegExp(`(\\s|^)${cls}(\\s|$)`)
                    ele.className = ele.className.replace(reg, ' ')
                }
            },
            addDate(date, days) {
                if (days == undefined || days == '') {
                    days = 1
                }
                var date = new Date(date)
                date.setDate(date.getDate() + days)
                const month = date.getMonth() + 1
                const day = date.getDate()
                return `${date.getFullYear()}-${this.getFormatDate(month)}-${this.getFormatDate(day)}`
            },
            getFormatDate(arg) {
                if (arg == undefined || arg == '') {
                    return ''
                }

                let re = `${arg}`
                if (re.length < 2) {
                    re = `0${re}`
                }
                return re
            },
            getTime2Time($time1, $time2) {
                let time1 = arguments[0]
                let time2 = arguments[1]
                time1 = Date.parse(time1) / 1000
                time2 = Date.parse(time2) / 1000
                const time_gas = time1 - time2
                return (time_gas / (3600 * 24))
            },
            getExplore() {
                const sys = {}
                const ua = navigator.userAgent.toLowerCase()
                let s;
                (s = ua.match(/rv:([\d.]+)\) like gecko/)) ? sys.ie = s[1]: (s = ua.match(/msie ([\d\.]+)/)) ? sys.ie = s[1] :
                    (s = ua.match(/edge\/([\d\.]+)/)) ? sys.edge = s[1] :
                    (s = ua.match(/firefox\/([\d\.]+)/)) ? sys.firefox = s[1] :
                    (s = ua.match(/(?:opera|opr).([\d\.]+)/)) ? sys.opera = s[1] :
                    (s = ua.match(/chrome\/([\d\.]+)/)) ? sys.chrome = s[1] :
                    (s = ua.match(/version\/([\d\.]+).*safari/)) ? sys.safari = s[1] : 0
                // 根据关系进行判断
                if (sys.ie) {
                    return (`IE: ${sys.ie}`)
                }

                if (sys.edge) {
                    return (`EDGE: ${sys.edge}`)
                }

                if (sys.firefox) {
                    return (`Firefox: ${sys.firefox}`)
                }

                if (sys.chrome) {
                    return (`Chrome: ${sys.chrome}`)
                }

                if (sys.opera) {
                    return (`Opera: ${sys.opera}`)
                }

                if (sys.safari) {
                    return (`Safari: ${sys.safari}`)
                }
                return ''
            },
            getOS() {
                const userAgent = 'navigator' in window && 'userAgent' in navigator && navigator.userAgent.toLowerCase() || ''
                const vendor = 'navigator' in window && 'vendor' in navigator && navigator.vendor.toLowerCase() || ''
                const appVersion = 'navigator' in window && 'appVersion' in navigator && navigator.appVersion.toLowerCase() || ''

                if (/mac/i.test(appVersion)) {
                    return 'MacOSX'
                }
                if (/win/i.test(appVersion)) {
                    return 'windows'
                }
                if (/linux/i.test(appVersion)) {
                    return 'linux'
                }
                if (/iphone/i.test(userAgent) || /ipad/i.test(userAgent) || /ipod/i.test(userAgent)) {
                    return 'ios'
                }
                if (/android/i.test(userAgent)) {
                    return 'android'
                }

                if (/win/i.test(appVersion) && /phone/i.test(userAgent)) {
                    return 'windowsPhone'
                }
            },
            getScrollTop() {
                return (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop
            },
            offset(ele) {
                const pos = {
                    left: 0,
                    top: 0,
                }
                while (ele) {
                    pos.left += ele.offsetLeft
                    pos.top += ele.offsetTop
                    ele = ele.offsetParent
                }
                return pos
            },
            requestAnimFrame() {
                return window.requestAnimationFrame ||
                    window.webkitRequestAnimationFrame ||
                    window.mozRequestAnimationFrame ||
                    function (callback) {
                        window.setTimeout(callback, 1000 / 60)
                    }
            },
            keyCodeMap() {
                return {
                    8: 'Backspace',
                    9: 'Tab',
                    13: 'Enter',
                    16: 'Shift',
                    17: 'Ctrl',
                    18: 'Alt',
                    19: 'Pause',
                    20: 'Caps Lock',
                    27: 'Escape',
                    32: 'Space',
                    33: 'Page Up',
                    34: 'Page Down',
                    35: 'End',
                    36: 'Home',
                    37: 'Left',
                    38: 'Up',
                    39: 'Right',
                    40: 'Down',
                    42: 'Print Screen',
                    45: 'Insert',
                    46: 'Delete',
                    48: '0',
                    49: '1',
                    50: '2',
                    51: '3',
                    52: '4',
                    53: '5',
                    54: '6',
                    55: '7',
                    56: '8',
                    57: '9',
                    65: 'A',
                    66: 'B',
                    67: 'C',
                    68: 'D',
                    69: 'E',
                    70: 'F',
                    71: 'G',
                    72: 'H',
                    73: 'I',
                    74: 'J',
                    75: 'K',
                    76: 'L',
                    77: 'M',
                    78: 'N',
                    79: 'O',
                    80: 'P',
                    81: 'Q',
                    82: 'R',
                    83: 'S',
                    84: 'T',
                    85: 'U',
                    86: 'V',
                    87: 'W',
                    88: 'X',
                    89: 'Y',
                    90: 'Z',
                    91: 'Windows',
                    93: 'Right Click',
                    96: 'Numpad 0',
                    97: 'Numpad 1',
                    98: 'Numpad 2',
                    99: 'Numpad 3',
                    100: 'Numpad 4',
                    101: 'Numpad 5',
                    102: 'Numpad 6',
                    103: 'Numpad 7',
                    104: 'Numpad 8',
                    105: 'Numpad 9',
                    106: 'Numpad *',
                    107: 'Numpad +',
                    109: 'Numpad -',
                    110: 'Numpad .',
                    111: 'Numpad /',
                    112: 'F1',
                    113: 'F2',
                    114: 'F3',
                    115: 'F4',
                    116: 'F5',
                    117: 'F6',
                    118: 'F7',
                    119: 'F8',
                    120: 'F9',
                    121: 'F10',
                    122: 'F11',
                    123: 'F12',
                    144: 'Num Lock',
                    145: 'Scroll Lock',
                    182: 'My Computer',
                    183: 'My Calculator',
                    186: ';',
                    187: '=',
                    188: ',',
                    189: '-',
                    190: '.',
                    191: '/',
                    192: '`',
                    219: '[',
                    220: '\\',
                    221: ']',
                    222: '\'',
                }
            },
            getKeyName(keycode) { //
                if (this.keyCodeMap()[keycode]) {
                    return this.keyCodeMap()[keycode]
                }
                return ''
            },
            digitUppercase(n) {
                if (isNaN(n)) return '数据非法'
                if (n == 0 || n == null || n == '') return '零圆整'
                let fsval = ''
                if (n < 0) fsval = '(负数)'

                const n_split = (`${n}`).split('.')
                if (n_split.length > 1 && n_split[1].length > 2) n = parseFloat(n).toFixed(2) // 有2位以上小数时，四舍五入

                n = Math.abs(n)

                let unit = '仟佰拾亿仟佰拾万仟佰拾圆角分';
                let
                    str = ''
                n += '00'
                const p = n.indexOf('.')
                if (p >= 0) n = n.substring(0, p) + n.substr(p + 1, 2)
                unit = unit.substr(unit.length - n.length)
                for (let i = 0; i < n.length; i++) str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i)
                return fsval + str.replace(/零(仟|佰|拾|角)/g, '零').replace(/(零)+/g, '零').replace(/零(万|亿|圆)/g, '$1').replace(/(亿)万|(拾)/g, '$1$2')
                    .replace(/^圆零?|零分/g, '')
                    .replace(/圆$/g, '圆整')
            },
            parseQueryString(url) { // url参数转对象
                var url = url == null ? window.location.href : url
                const search = url.split('?')[1]
                if (!search) {
                    return {}
                }
                return JSON.parse(`{"${decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"')}"}`)
            },
            stringfyQueryString(obj) { // 对象序列化
                if (!obj) {
                    return ''
                }
                const pairs = []
                for (const key in obj) {
                    const value = obj[key]
                    if (value instanceof Array) {
                        for (let i = 0; i < value.length; ++i) {
                            pairs.push(`${encodeURIComponent(`${key}[${i}]`)}=${encodeURIComponent(value[i])}`)
                        }
                        continue
                    }
                    pairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
                }
                return pairs.join('&')
            },
            isSupportWebP() { // 判断浏览器是否支持webP格式图片
                return !![].map && document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0
            },
            formatRemainTime(endTime) { // 格式化现在距${endTime}的剩余时间
                const startDate = new Date()
                // 开始时间
                const endDate = new Date(endTime)
                // 结束时间
                const t = endDate.getTime() - startDate.getTime()
                // 时间差
                let d = 0
                let h = 0
                let m = 0
                let s = 0

                if (t >= 0) {
                    d = Math.floor(t / 1000 / 3600 / 24)
                    h = Math.floor(t / 1000 / 60 / 60 % 24)
                    m = Math.floor(t / 1000 / 60 % 60)
                    s = Math.floor(t / 1000 % 60)
                }
                return `${d}天 ${h}小时 ${m}分钟 ${s}秒`
            },
            formatPassTime(startTime) { // 格式化${startTime}距现在的已过时间
                const currentTime = Date.parse(new Date())
                const time = currentTime - startTime
                const day = parseInt(time / (1000 * 60 * 60 * 24))
                const hour = parseInt(time / (1000 * 60 * 60))
                const min = parseInt(time / (1000 * 60))
                const month = parseInt(day / 30)
                const year = parseInt(month / 12)
                if (year) {
                    return `${year}年前`
                }
                if (month) {
                    return `${month}个月前`
                }
                if (day) {
                    return `${day}天前`
                }
                if (hour) {
                    return `${hour}小时前`
                }
                if (min) {
                    return `${min}分钟前`
                }
                return '刚刚'
            },
            throttle(delay, noTrailing, callback, debounceMode) {
                /**
                 * @desc   函数节流。
                 * 适用于限制`resize`和`scroll`等函数的调用频率
                 *
                 * @param  {Number}    delay          0 或者更大的毫秒数。 对于事件回调，大约100或250毫秒（或更高）的延迟是最有用的。
                 * @param  {Boolean}   noTrailing     可选，默认为false。
                 *                                    如果noTrailing为true，当节流函数被调用，每过`delay`毫秒`callback`也将执行一次。
                 *                                    如果noTrailing为false或者未传入，`callback`将在最后一次调用节流函数后再执行一次.
                 *                                    （延迟`delay`毫秒之后，节流函数没有被调用,内部计数器会复位）
                 * @param  {Function}  callback       延迟毫秒后执行的函数。`this`上下文和所有参数都是按原样传递的，
                 *                                    执行去节流功能时，调用`callback`。
                 * @param  {Boolean}   debounceMode   如果`debounceMode`为true，`clear`在`delay`ms后执行。
                 *                                    如果debounceMode是false，`callback`在`delay` ms之后执行。
                 *
                 * @return {Function}  新的节流函数
                 */
                let timeoutID
                let lastExec = 0
                if (typeof noTrailing !== 'boolean') {
                    debounceMode = callback
                    callback = noTrailing
                    noTrailing = undefined
                }

                function wrapper() {
                    const self = this
                    const elapsed = Number(new Date()) - lastExec
                    const args = arguments

                    function exec() {
                        lastExec = Number(new Date())
                        callback.apply(self, args)
                    }

                    function clear() {
                        timeoutID = undefined
                    }
                    if (debounceMode && !timeoutID) {
                        exec()
                    }
                    if (timeoutID) {
                        clearTimeout(timeoutID)
                    }
                    if (debounceMode === undefined && elapsed > delay) {
                        exec()
                    } else if (noTrailing !== true) {
                        timeoutID = setTimeout(debounceMode ? clear :
                            exec, debounceMode ===
                            undefined ?
                            delay - elapsed : delay)
                    }
                }
                return wrapper
            },
            debounce(delay, atBegin, callback) {
                /**
                 * @desc 函数防抖
                 * 与throttle不同的是，debounce保证一个函数在多少毫秒内不再被触发，只会执行一次，
                 * 要么在第一次调用return的防抖函数时执行，要么在延迟指定毫秒后调用。
                 * @example 适用场景：如在线编辑的自动存储防抖。
                 * @param  {Number}   delay         0或者更大的毫秒数。 对于事件回调，大约100或250毫秒（或更高）的延迟是最有用的。
                 * @param  {Boolean}  atBegin       可选，默认为false。
                 *                                  如果`atBegin`为false或未传入，回调函数则在第一次调用return的防抖函数后延迟指定毫秒调用。
                                                    如果`atBegin`为true，回调函数则在第一次调用return的防抖函数时直接执行
                 * @param  {Function} callback      延迟毫秒后执行的函数。`this`上下文和所有参数都是按原样传递的，
                 *                                  执行去抖动功能时，，调用`callback`。
                 *
                 * @return {Function} 新的防抖函数。
                 */
                const {
                    throttle
                } = this
                return function (delay, atBegin, callback) {
                    return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false)
                }
            },
            deepClone(values) { // 深拷贝
                let copy
                if (values == null || typeof values !== 'object') {
                    return values
                }
                // Handle Date
                if (values instanceof Date) {
                    copy = new Date()
                    copy.setTime(values.getTime())
                    return copy
                }
                // Handle Array
                if (values instanceof Array) {
                    copy = []
                    for (let i = 0, len = values.length; i < len; i++) {
                        copy[i] = this.deepClone(values[i])
                    }
                    return copy
                }
                // Handle Object
                if (values instanceof Object) {
                    copy = {}
                    for (const attr in values) {
                        if (values.hasOwnProperty(attr)) copy[attr] = this.deepClone(values[attr])
                    }
                    return copy
                }
                throw new Error('Unable to copy values! Its type isn\'t supported.')
            },
            isEmptyObject(obj) { // 判断`obj`是否为空
                if (!obj || typeof obj !== 'object' || Array.isArray(obj)) {
                    return false
                }
                return !Object.keys(obj).length
            },

        }
    }())
    // YSY user
    YSY.user = (function () {
        return {
            init() {
                const user = this.info() || ''
            },
            info() {
                const cookie = YSY.cookie('YSY_TOKEN')
                if (!cookie || cookie.split('|').length != 2) {
                    return null
                }
                return cookie
                // var info = cookie.split('|');
                // return {
                //     name: info[0],
                //     type: info[1]
                // };
            },
        }
    }())
    // 初始化
    YSY.init()
    return YSY || {}
}


// WEBPACK FOOTER //
// ./src/components/globalFn/globalFnFactory.js